export default "__VITE_ASSET__DIi3kEBM__"